export const trimHexColor = (value: unknown): string =>
  typeof value === 'string' ? value.trim() : ''

const hexToRgb = (hex: string) => {
  const rgbHex = trimHexColor(hex).replace('#', '').match(/.{1,2}/g)
  return rgbHex
    ? [
        parseInt(rgbHex[0], 16),
        parseInt(rgbHex[1], 16),
        parseInt(rgbHex[2], 16)
      ]
    : null
}

const rgbToHex = (r: number, g: number, b: number) => {
  return '#' + [r, g, b].map(x => {
    const hex = x.toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }).join('')
}

export const adjust = (color: string, amount: number) => {
  return (
    '#' +
    trimHexColor(color)
      .replace(/^#/, '')
      .replace(/../g, c =>
        (
          '0' +
          Math.min(255, Math.max(0, parseInt(c, 16) + amount)).toString(16)
        ).substr(-2)
      )
  )
}

export const lighter = (color: string, factor: number) => {
  const rgb = hexToRgb(color)

  const newRgb = rgb?.map((value) => Math.round((value + ((255 - value) * factor))))

  return newRgb?.length ? rgbToHex(newRgb[0], newRgb[1], newRgb[2]) : null
}

export const darker = (color: string, factor: number) => {
  const rgb = hexToRgb(color)

  const newRgb = rgb?.map((value) => Math.round((value * (1 - factor))))

  return newRgb?.length ? rgbToHex(newRgb[0], newRgb[1], newRgb[2]) : null
}

export const createThemeColors = (primary: string, secondary: string) => {
  const trimmedPrimary = trimHexColor(primary)
  const trimmedSecondary = trimHexColor(secondary)

  return {
    primary: {
      50: lighter(trimmedPrimary, 0.9),
      100: lighter(trimmedPrimary, 0.8),
      200: lighter(trimmedPrimary, 0.6),
      300: lighter(trimmedPrimary, 0.4),
      400: lighter(trimmedPrimary, 0.1),
      500: trimmedPrimary,
      600: darker(trimmedPrimary, 0.1),
      700: darker(trimmedPrimary, 0.4),
      800: darker(trimmedPrimary, 0.6),
      900: darker(trimmedPrimary, 0.8)
    },
    secondary: {
      50: lighter(trimmedSecondary, 0.9),
      100: lighter(trimmedSecondary, 0.8),
      200: lighter(trimmedSecondary, 0.6),
      300: lighter(trimmedSecondary, 0.4),
      400: lighter(trimmedSecondary, 0.1),
      500: trimmedSecondary,
      600: darker(trimmedSecondary, 0.1),
      700: darker(trimmedSecondary, 0.4),
      800: darker(trimmedSecondary, 0.6),
      900: darker(trimmedSecondary, 0.8)
    }
  }
}

export const uuidToColor = (uuid: string) => {
  let hash = 0

  for (let i = 0; i < uuid.length; i++) {
    hash = uuid.charCodeAt(i) + ((hash << 5) - hash)
  }

  const color = `#${((hash >> 16) & 0xFF).toString(16).padStart(2, '0')}` +
                `${((hash >> 8) & 0xFF).toString(16).padStart(2, '0')}` +
                `${(hash & 0xFF).toString(16).padStart(2, '0')}`

  return color
}
